<template>
  <svg width="6.438" height="32">
    <path d="M.517 19.234a10.32 10.32 0 0 1 0-6.454L4.497.691a.994.994 0 0 1 1.94.323V30.99a1 1 0 0 1-1.95.323Z" fill="currentColor"/>
  </svg>
</template>
